export default "__VITE_ASSET__e1b6bc16__"